export default function exportProspectList(params) {
  this.printFile({module: params.module, id: params.id});
}